import { render, staticRenderFns } from "./NewsTicker.vue?vue&type=template&id=892ef8b8&scoped=true&"
import script from "./NewsTicker.vue?vue&type=script&lang=js&"
export * from "./NewsTicker.vue?vue&type=script&lang=js&"
import style0 from "./NewsTicker.vue?vue&type=style&index=0&id=892ef8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892ef8b8",
  null
  
)

export default component.exports